// @tennis-matches/services/winterdoppel/playerDisplay

export function normalizeWinterDoppelPlayerName(name) {
  return String(name || "")
    .trim()
    .toLowerCase();
}

/** Gruppen mit gleichem Namen (case-insensitive) in einer Serie. */
export function findWinterDoppelDuplicateNameGroups(players = []) {
  const byNorm = new Map();
  for (const p of players || []) {
    if (!p?.id) continue;
    const norm = normalizeWinterDoppelPlayerName(p.display_name);
    if (!norm) continue;
    const list = byNorm.get(norm) || [];
    list.push(p);
    byNorm.set(norm, list);
  }
  return [...byNorm.values()].filter((g) => g.length > 1);
}

/**
 * Anzeigenamen je Spieler-ID; bei Namens-Duplikaten Telefon oder ID-Kürzel.
 * @returns {Map<string, string>}
 */
export function buildWinterDoppelPlayerDisplayNames(players = []) {
  const groups = findWinterDoppelDuplicateNameGroups(players);
  const dupIds = new Set(groups.flat().map((p) => String(p.id)));

  const labels = new Map();
  for (const p of players || []) {
    if (!p?.id) continue;
    const id = String(p.id);
    let label = String(p.display_name || "").trim() || id;
    if (dupIds.has(id)) {
      const hint = String(p.phone || "").trim() || id.slice(0, 8);
      label = `${label} (${hint})`;
    }
    labels.set(id, label);
  }
  return labels;
}

export function assertWinterDoppelPlayerNameUnique(
  players = [],
  displayName,
  excludePlayerId = "",
) {
  const norm = normalizeWinterDoppelPlayerName(displayName);
  if (!norm) return;
  const exclude = String(excludePlayerId || "");
  const dup = (players || []).find(
    (p) =>
      p?.id &&
      normalizeWinterDoppelPlayerName(p.display_name) === norm &&
      String(p.id) !== exclude,
  );
  if (dup) {
    throw new Error("winterdoppel.player.duplicateName");
  }
}
